import { DatePipe } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import * as _ from 'lodash';
import {Subscription} from 'rxjs';
import {debounceTime, filter} from 'rxjs/operators';
import { ICountry } from 'src/app/core/models/country.interface';
import { PlaceStatus } from 'src/app/shared/enums/place-status.enum';
import { Roles } from 'src/app/shared/enums/role-types.enum';
import { OriginCountryPopupDialog } from 'src/app/shared/popups/origin-country/origin-country-popup.component';
import {IAvailableTypes, IConstantItem} from '../../../core/models/available-types.interface';
import {PageParams} from '../../../core/models/page-params.model';
import {ConstantService} from '../../../core/services/constant.service';
import {MarketplacesService} from '../../../core/services/marketplaces.service';
import {NotificationService} from '../../../core/services/notification.service';
import {UploadFileService} from '../../../core/services/upload-file.service';
import {UserService} from '../../../core/services/user.service';
//import {CustomerType} from '../../../shared/enums/customer-type.enum';
import {SaleOrderStatus} from '../../../shared/enums/sale-order-status.enum';
import {SaleOrderType} from '../../../shared/enums/sale-order-type.enum';
import {ConfirmPopupDialog} from '../../../shared/popups/confirm-popup/confirm-popup.component';
import {CustomerPopupDialog} from '../../../shared/popups/customer-popup/customer-popup.component';
import {HideShowFieldsComponent} from '../../../shared/popups/hideshow-fields/hideshowfields.component';
import {ConsolidateShipmentsDetailsComponent} from '../../consolidate-shipments/components/consolidate-shipments-details/consolidate-shipments-details.component';
import {RegistrationService} from '../../customer-registration/services/registration.service';
import {FieldList} from '../components/hideshow-fields-param';
import {SaleOrderDetailsComponent} from '../components/sale-order-details/sale-order-details.component';
import {ISaleOrder} from '../models/sale-order.interface';
import {SaleOrderService} from '../services/sale-order.service';
import { XlsxUploadPopupPopupComponent } from './xlsx-upload-popup/xlsx-upload-popup.component';
import { ShipmentSubType } from 'src/app/shared/enums/shipment-subtype.enum';
import { ShipmentSubtypeSelectPopupComponent } from 'src/app/shared/popups/shipment-subtype-select-popup/shipment-subtype-select-popup.component';
import { ConsolidateShipmentService } from 'src/app/core/services/consolidate-shipments.service';
import { deliveredStatuses } from 'src/app/core/constants.enum';

const Field_List: FieldList[] = [
    {
        key: 'reorder',
        value: false,
        label: 'Reorder'
    },
    {
        key: 'eciOrderDate',
        value: false,
        label: 'Empact Order Date'
    },
    {
        key: 'orderId',
        value: false,
        label: 'Order Id'
    },
    {
        key: 'stripeAmount',
        value: false,
        label: 'Stripe Amount'
    },
    {
        key: 'stripeRefundAmount',
        value: false,
        label: 'Stripe Refund Amount'
    },
    {
        key: 'marketplaceVat',
        value: false,
        label: 'Market place VAT'
    },
    {
        key: 'conversionRate',
        value: false,
        label: 'Conversion Rate'
    },
    {
        key: 'empactVatAmountEur',
        value: false,
        label: 'Empact VAT Amount (EUR)'
    },
    {
        key: 'empactTotalOrderAmountEur',
        value: false,
        label: 'Emapct Total Order Amount (EUR)'
    },
    {
        key: 'eciVat',
        value: false,
        label: 'Amount Exc.VAT'
    },
];

@Component({
    selector: 'eci-invat-order-search-page',
    templateUrl: './invat-order-search-page.component.html',
    styleUrls: ['./invat-order-search-page.component.scss']
})
export class InvatOrderSearchPageComponent implements OnInit, OnDestroy {
    @ViewChild('fileInput') fileInput: any;

    sub$: Subscription = new Subscription();
    pageParams: PageParams = new PageParams();
    fromData: FormControl = new FormControl('');
    toData: FormControl = new FormControl('');

    fromDataEmpact: FormControl = new FormControl('');
    toDataEmpact: FormControl = new FormControl('');

    deliveryFromDate: FormControl = new FormControl('');
    deliveryToDate: FormControl = new FormControl('');

    marketplaces: FormControl = new FormControl(null);
    orderStatus: FormControl = new FormControl(null);
    searchStr = new FormControl('');
    searchorMarketplaces: FormControl = new FormControl('');
    searchorderStatus: FormControl = new FormControl('');
    //searchcustomerType: FormControl = new FormControl('');// Deprecate Company type
    searchCustomerName: FormControl = new FormControl('');
    customerName: FormControl = new FormControl('');
    currentSort: Sort;
    sumOfTotalFIelds: any = [];
    sumOfTotalFIeldsIncludingCancelled: any = [];
    previousUrl: string = null;
    currentUrl: string = null;
    availableTypes: IAvailableTypes;
    showLoader: boolean = false;
    saleOrdersList: ISaleOrder[];

    originCountry: FormControl = new FormControl('');
    originSearchCountry = new FormControl('');
    availableOriginCountries: ICountry[];

    destinationCountry: FormControl = new FormControl('');
    destinationSearchCountry = new FormControl('');
    availableDestinationCountries: ICountry[];

    listOfSelectedItems: number[] = [];
    listOfSelectedItemsBody: ISaleOrder[] = [];

    previousePageCustomer: number = 0;
    totalPagesCustomers: number = 0;

    companyList: any[];
    routeSubscription: Subscription;

    fullCountriesList: ICountry[];

    uploadSubscription;
    addNewSaleOrder: boolean = false;

    fieldList = Field_List;

    public shipmentSubtype: ShipmentSubType = ShipmentSubType.Regular;

    @ViewChild('marketplaceSelect', { static: true }) marketplaceSelect: MatSelect;
    @ViewChild('orderStatusSelect', { static: true }) orderStatusSelect: MatSelect;
    @ViewChild('companySelect', { static: true }) companySelect: MatSelect;
    @ViewChild('originCountrySelect', { static: true }) originCountrySelect: MatSelect;
    @ViewChild('destinationCountrySelect', { static: true }) destinationCountrySelect: MatSelect;

    get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ?
            this.getList(e.pageIndex + 1, e.pageSize, this.searchStr.value) :
            this.getList(e.pageIndex + 1, e.pageSize, this.searchStr.value, this.userSvc.company.id);
    }

    constructor(
        private router: Router,
        public userSvc: UserService,
        private dialog: MatDialog,
        private saleOrderSvc: SaleOrderService,
        private datePipe: DatePipe,
        private constSvc: ConstantService,
        private notify: NotificationService,
        private marketplaceSvc: MarketplacesService,
        private regSvc: RegistrationService,
        public uploadFileSvc: UploadFileService,
        private route: ActivatedRoute,
        private consolidateShipmentService: ConsolidateShipmentService
    ) { }

    displayedColumns: string[] = [
        'checkboxes',
        'donwloadDocuments',
        'reorder',
        //'hasErrors',
        'returns',
        'eciOrderDate',
        'orderDate',
        'deliveryDate',
        'customerName',
        //'customerType',// Deprecate Company type
        'shopId',
        'shopName',
        'orderID',
        'morderID',
        'originCountryName',
        'countryName',
        'carrier',
        'trackingNumber',
        'orderCurrency',
        'stripeAmount',
        'stripeRefundAmount',
        'conversionRate',
        'eciVat',
        'totalWithoutVat',
        'vatCharges',
        'empactVatAmountEur',
        'empactTotalOrderAmountEur',
        'orderAmount',
        'marketPlace',
        'orderStatus',

        // ADED FOR QA TEAM - NOT VISIBLE IN UI FOR USERS
        'eciSellOrderTotalTest',
        'shippingPriceTest',
        'productsTest',
        // 'syncAftershipRefresh',
    ];
    dataSource;

    // get customerTypes(): IConstantItem[] {
    //     if (!this.availableTypes) return;
    //     return this.availableTypes.CompanyType;
    // }

    get marketplaceTypes(): IConstantItem[] {
        return this.marketplaceSvc?.availableMarketplaces$?.getValue();
    }

    get orderStatuses(): IConstantItem[] {
        if (!this.availableTypes) return;
        return this.availableTypes.SaleOrderStatus;
    }

    get isDelegateAdmin(): boolean {
        return this.userSvc.userStorage.role == Roles.DelicateAdmin;
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        // commented because it's creating an error when we are logout
        // bug https://github.com/Zangula/ECommIn_project_management/issues/3569
        // const req = {
        //     name: 'INDVAT_SALES_ORDER_VISIBLITY_FIELD_RULE',
        //     label: 'INDVAT_SALES_ORDER_VISIBLITY_FIELD_RULE Listview Fields setting',
        //     value: JSON.stringify(Field_List)
        // };
        /*this.constSvc.saveSettings(req).subscribe(data => {
            this.routeSubscription && this.routeSubscription.unsubscribe();
            if (!data) { return; }
        });*/
    }

    ngOnInit(): void {
        if(this.isAdmin){
            this.displayedColumns.splice(12, 0, 'batchId');
            this.displayedColumns.splice(13, 0, 'consolNumber');
            this.displayedColumns.splice(14, 0, 'batchOriginCountryName');
            this.displayedColumns.splice(15, 0, 'batchDestinationCountryName');
            this.displayedColumns.splice(16, 0, 'fileName');
            this.displayedColumns.splice(17, 0, 'batchType');
        } else {
            this.displayedColumns.splice(13, 0, 'regularConsolNumber');            
        }

        this.routeSubscription = this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            if (event.url != "/") {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
                // commented because it's creating an error when we are logout
                // bug https://github.com/Zangula/ECommIn_project_management/issues/3569
                // if (this.previousUrl != this.currentUrl && this.currentUrl != '/sales-order-management/indvat-sales-order-management') {
                //     const req = {
                //         name: 'INDVAT_SALES_ORDER_VISIBLITY_FIELD_RULE',
                //         label: 'INDVAT_SALES_ORDER_VISIBLITY_FIELD_RULE Listview Fields setting',
                //         value: JSON.stringify(this.fieldList)
                //     };
                //     this.constSvc.saveSettings(req).subscribe(data => {
                //         this.routeSubscription && this.routeSubscription.unsubscribe();
                //         if (!data) { return; }
                //     });
                // }
            }
        });
        this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ?
            this.getList(1, 100, '') :
            this.getList(1, 100, '', this.userSvc.company.id);

        this.constSvc.availableTypes.subscribe(data => {
            this.availableTypes = data;
        })

        this.searchStr.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.search();
        });

        this.getListCompanies();

        this.searchCustomerName.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.previousePageCustomer = 0;
            this.getListCompanies();
        });

        this.originSearchCountry.valueChanges.subscribe(value => {
            if (value) {
                this.availableOriginCountries = this.fullCountriesList.filter(c => c.name.toLowerCase().includes(value.toLowerCase()));
            } else {
                this.availableOriginCountries = this.fullCountriesList;
            }
        });

        this.destinationSearchCountry.valueChanges.subscribe(value => {
            if (value) {
                this.availableDestinationCountries = this.fullCountriesList.filter(c => c.name.toLowerCase().includes(value.toLowerCase()));
            } else {
                this.availableDestinationCountries = this.fullCountriesList;
            }
        });

        this.getListOfCountries( '', 1);

        /*this.constSvc.getAvailableCountries().subscribe(data => {
            this.fullCountriesList = data;
        });*/
    }

    getListOfCountries(
        q: string,
        page: number,
        limit: number = 1000,
    ): void {
        this.constSvc.getAvailableCountriesForScroll(page, limit, false, q).subscribe(data => {
            if (!data) { return; }
            this.fullCountriesList = data.items;
            this.availableOriginCountries = data.items;
            this.availableDestinationCountries = data.items;
        });
    }

    async getList(
        page: number = this.pageParams?.pageIndex + 1,
        limit: number = this.pageParams?.pageSize,
        q: string = this.searchStr.value,
        companyId: number = this.customerName.value,
        isSelectAll: boolean = false,
        originCountry: string = this.originCountry.value,
        destinationCountry: string = this.destinationCountry.value,
        orderField: string = this.currentSort?.active || '',
        orderDir: string = this.currentSort?.direction.toUpperCase() || ''
    ): Promise<void> {
        this.showLoader = true;
        await this.saleOrderSvc.getOrders(
            page,
            limit,
            q,
            companyId,
            '',
            '',
            '',
            this.prepareSearchParams,
            orderField,
            orderDir,
            false,
            SaleOrderType.All.toString(),
            true,
            PlaceStatus.Confirmed,
            {
                originCountry,
                destinationCountry,
                dateToEmpact: this.toDataEmpact.value ? this.datePipe.transform(this.toDataEmpact.value, 'yyyy-MM-dd') : '',
                dateFromEmpact: this.toDataEmpact.value && this.fromDataEmpact.value ? this.datePipe.transform(this.fromDataEmpact.value, 'yyyy-MM-dd') : '',
                deliveryDateTo: this.deliveryToDate.value ? this.datePipe.transform(this.deliveryToDate.value, 'yyyy-MM-dd') : '',
                deliveryDateFrom: this.deliveryFromDate.value && this.deliveryFromDate.value ? this.datePipe.transform(this.deliveryFromDate.value, 'yyyy-MM-dd') : '',
            },
            isSelectAll
        ).subscribe({
            next: (data) => {
                this.showLoader = false;
                if (!data) {
                    return;
                }
                if(isSelectAll){
                    this.showLoader = false;
                    this.listOfSelectedItems = data.items.map(item => item.id);
                    this.listOfSelectedItemsBody = [];
                }else{
                     /*let sortData = data.items.sort(function(a,b){
                        return new Date(b.orderDate).valueOf() - new Date(a.orderDate).valueOf();
                    });*/
                    /*const duplicates = this.findDuplicate(data.items);
                    for (const item of data.items) {
                        if(duplicates.length > 0) {
                            const marketplaceOrderId = (item?.marketplace?.marketplaceOrderId?.length > 6 ?
                                item?.marketplace?.marketplaceOrderId?.slice(-5) : item?.marketplace?.marketplaceOrderId);
                            if (duplicates.indexOf(marketplaceOrderId) > -1) {
                                item['color'] = '#eba5a5';
                            }
                        }
                    }*/
                    this.dataSource = data.items;
                    this.saleOrdersList = data.items;
                    this.pageParams.pageSize = data.meta.itemsPerPage;
                    this.pageParams.pageIndex = data.meta.currentPage - 1;
                    this.pageParams.length = data.meta.totalItems;
                    this.sumOfTotalFIelds = data.totals[0];
                }
            },
            error: (err) => {
                console.error('sale Order error:', err);
                this.showLoader = false;
            }
        });
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(SaleOrderDetailsComponent, {
            maxHeight: '600px',
            width: '900px',
            data: {
                disableB2BShipment: true
            }
        });
        dialogRef.componentInstance.createMode = true;
        dialogRef.componentInstance.header = "Sales Management - Add Sales Order";
        dialogRef.componentInstance.marginTop = '0';
        dialogRef.afterClosed().subscribe(result => {
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.getList(1, 100, '') : this.getList(1, 100, '', this.userSvc.company.id);
        });
    }

    openCustomerDialog(): void {
        const dialogRef = this.dialog.open(CustomerPopupDialog);
        dialogRef.afterClosed().subscribe(result => {
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.getList(1, 100, '') : this.getList(1, 100, '', this.userSvc.company.id);
        });
    }

    get prepareSearchParams(): any {
        return {
            marketplaces: this.marketplaces.value ? this.marketplaces.value : '',
            // companyTypes: this.customerType.value ? this.customerType.value : '',
            //companyTypes: CustomerType['Reporting Tool'],// Deprecate Company type
            dateTo: this.toData.value && this.toData.value !== null ? this.datePipe.transform(this.toData.value, 'yyyy-MM-dd') : '',
            dateFrom: this.toData.value && this.fromData.value !== null ? this.datePipe.transform(this.fromData.value, 'yyyy-MM-dd') : '',
            orderStatus: this.orderStatus.value ? this.orderStatus.value : '',
        }
    }

    sortData(sort: Sort): void {
        // const data = this.saleOrdersList.slice();
        /*if (!sort.active || sort.direction === '') {
            this.saleOrdersList = data;
            this.dataSource = new MatTableDataSource<IOrderListItem>(this.saleOrdersList);
            return;
        }*/

        this.currentSort = sort;
        this.getList(
            this.pageParams?.pageIndex + 1,
            this.pageParams?.pageSize,
            this.searchStr.value || '',
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? '' : this.userSvc.company.id
        );
    }

    search(): void {
        this.clearSelection();
        this.getList(1, 100, this.searchStr.value, this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.customerName.value : this.userSvc.company.id);
    }

    deleteOrders(): void {
        if (!this.listOfSelectedItems) return;
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm deleting';
        dialogRef.componentInstance.rightBtnText = 'Delete';
        dialogRef.afterClosed().subscribe(value => {
            if (!value) return;

            this.saleOrderSvc.deleteOrders(this.listOfSelectedItems).subscribe(() => {
                this.getList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage('Deleted successfully');
            }, err => {
                this.notify.showError('Something went wrong');
                console.log('Error => ', err);
            });
        });
    }

    regenerateOrdersInvoice(): void {
        if (!this.listOfSelectedItems) return;
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm regeneration of invoice';
        dialogRef.componentInstance.rightBtnText = 'Regenerate Invoice';
        dialogRef.afterClosed().subscribe(value => {
            if (!value) return;

            this.saleOrderSvc.regenrateOrdersInvoice(this.listOfSelectedItems).subscribe(() => {
                this.getList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage('Invoice Regenerated successfully');
            }, err => {
                this.notify.showSuccessMessage('Something went wrong');
                console.log('Error => ', err);
            });
        });
    }

    deleteDuplicateds(): void {
        if (!this.customerName?.value) return;
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm deleting';
        dialogRef.componentInstance.rightBtnText = 'Delete';
        dialogRef.afterClosed().subscribe(value => {
            if (!value) return;

            this.saleOrderSvc.deleteMultipleOrder({ companyId: this.customerName?.value }).subscribe(() => {
                this.getList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage('Deleted successfully');
            }, err => {
                this.notify.showSuccessMessage('Something went wrong');
                console.log('Error => ', err);
            });
        });
    }

    getListCompanies(q: string = this.searchCustomerName.value): void {
        q = this.searchCustomerName.value ? this.searchCustomerName.value : q;
        this.regSvc.getCompanyListForSales(q, true).subscribe(data => {
            if (!data) return;
            this.companyList = data;
        })
    }

    clearSelection() {
        this.customerName.reset();
        this.getListCompanies(this.searchCustomerName.value);
        this.listOfSelectedItems =[];
        this.listOfSelectedItemsBody = [];
        
    }

    downloadDoc(element): void {
        this.saleOrderSvc.downloadFile(element?.id, element?.orderDocuments[0]?.id);
    }

    uploadDoc(el: { saleOrderId: number, id: number, e: any, file: any }): void {
        const files = el.e.dataTransfer ? el.e.dataTransfer.files : el.e.target.files;

        this.uploadSubscription = this.saleOrderSvc.fileLoadedObserver.subscribe(() => {
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ?
                this.getList(1, 100, '') :
                this.getList(1, 100, '', this.userSvc.company.id);
        })

        this.saleOrderSvc.uploadFile(files, el.saleOrderId, el.id);
    }

    updateDocs(id, body, element): void {
        this.saleOrderSvc.updateOrderDoc(element?.id, id, body).subscribe(data => {
            this.notify.showSuccessMessage('Document Uploaded');
        })
    }

    exportToExcel(): void {
        this.saleOrderSvc.downloadSaleOrders(
            this.pageParams?.pageIndex + 1,
            this.pageParams?.pageSize,
            this.searchStr.value,
            this.customerName.value,
            this.prepareSearchParams,
            this.currentSort?.active,
            this.currentSort?.direction.toUpperCase(),
            false,
            SaleOrderType.All.toString(),
            'INDVAT_SALES_ORDER_VISIBLITY_FIELD_RULE',
            PlaceStatus.Confirmed,
            true,
            {
                originCountry: this.originCountry.value,
                destinationCountry: this.destinationCountry.value,
                dateToEmpact: this.toDataEmpact.value ? this.datePipe.transform(this.toDataEmpact.value, 'yyyy-MM-dd') : '',
                dateFromEmpact: this.toDataEmpact.value && this.fromDataEmpact.value ? this.datePipe.transform(this.fromDataEmpact.value, 'yyyy-MM-dd') : '',
                deliveryDateTo: this.deliveryToDate.value ? this.datePipe.transform(this.deliveryToDate.value, 'yyyy-MM-dd') : '',
                deliveryDateFrom: this.deliveryFromDate.value && this.deliveryFromDate.value ? this.datePipe.transform(this.deliveryFromDate.value, 'yyyy-MM-dd') : '',
            }
        ).subscribe(() => {

        });
    }

    openHideShowFieldsPopup(): void {
        const dialogRef = this.dialog.open(HideShowFieldsComponent, {
            width: '500px',
            data: {fields: this.fieldList, settingName: 'INDVAT_SALES_ORDER_VISIBLITY_FIELD_RULE'}
        });
        dialogRef.afterClosed().subscribe(result => {
            if (!result) {
                return;
            }
            this.userSvc.hiddenFieldIndEvent.next("updates");
            this.fieldList = result;
            this.dataSource.data = result;
            this.getList();
        });
    }

    findDuplicate(data) {
        const marketplaceOrderId = data.map(item => (item?.marketplace?.marketplaceOrderId?.length > 6 ?
            item?.marketplace?.marketplaceOrderId?.slice(-5) : item?.marketplace?.marketplaceOrderId));
        return marketplaceOrderId.filter((item, index) => marketplaceOrderId.indexOf(item) !== index);
    }

    addNewSO(data) {
        this.consolidateShipmentService.getShipmentById(data).subscribe((res) => {
            if (res) {
                this.addNewSaleOrder = true;
                this.consolidateShipments(res);
            }
        });
    }

    consolidateShipments(data = null): void {
        const saleOrders = this.saleOrdersList.filter((so) => this.listOfSelectedItems.includes(so.id));
        const ids = saleOrders.map(so => so.id);

        // 1. Check if already in another Consolidation
        if (saleOrders.some(el => el.consolNumber != null)) {
            this.notify.showError('Selected items contain sale order which included to another Consol Shipment');
            return;
        }

        // 2. Check for mixed Finalized/Active statuses
        const hasFinalized = saleOrders.some(el => 
            deliveredStatuses.includes(el.status) || el.status === SaleOrderStatus.CANCELED
        );
        const hasActive = saleOrders.some(el => 
            !deliveredStatuses.includes(el.status) && el.status !== SaleOrderStatus.CANCELED
        );

        if (hasFinalized && hasActive) {
            this.notify.showError('Consolidate shipment could not combine Delivered or Canceled SO with other');
            return;
        }

        // 3. Strict check for any Delivered status
        if (saleOrders.some(el => deliveredStatuses.includes(el.status))) {
            this.notify.showError("Delivered sale orders cannot be consolidated");
            return;
        }

        // 4. Region-based validation (UK vs EU)
        const hasEUCountry = saleOrders.some(el => el.marketplace.buyer.shippingAddress.country.name !== 'United Kingdom');
        const hasUKCountry = saleOrders.some(el => el.marketplace.buyer.shippingAddress.country.name === 'United Kingdom');

        if (hasEUCountry && hasUKCountry) {
            this.notify.showError('Shipments with destination country UK can not be consolidated to shipments with country from EU');
            return;
        }

        if (this.addNewSaleOrder) {
            this.openConsolidateDialog(data, saleOrders);
        } else {
            const confirmDialog = this.dialog.open(ShipmentSubtypeSelectPopupComponent);
            
            // Use the constant here for the subtype popup trigger
            confirmDialog.componentInstance.isOnlyReturn = saleOrders.some(el => 
                deliveredStatuses.includes(el.status) || el.status === SaleOrderStatus.CANCELED
            );

            confirmDialog.afterClosed().subscribe(value => {
                if (value !== undefined) {
                    this.openConsolidateDialog(data, saleOrders, value);
                }
            });
        }
    }

    private openConsolidateDialog(data: any, saleOrders: any[], subtype: any = null): void {
        const dialogRef = this.dialog.open(ConsolidateShipmentsDetailsComponent, { 
            width: '90vw', 
            height: '80vh' 
        });
        
        dialogRef.componentInstance.summaryPage = false;
        dialogRef.componentInstance.existingConsolId = data?.id;
        dialogRef.componentInstance.info = data;
        dialogRef.componentInstance.createMode = true;
        dialogRef.componentInstance.isEditable = !!data?.id;
        dialogRef.componentInstance.saleOrders = _.cloneDeep(saleOrders);
        
        if (subtype) {
            dialogRef.componentInstance.subtype = subtype;
        }

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result?.type === 'summaryPage' && result?.status === 'open') {
                this.summaryDialog(result.data);
            }
        });
    }

    summaryDialog(data) {
        //  const saleOrders = this.saleOrdersList.filter((so) => this.listOfSelectedItems.includes(so.id));
        const saleOrders = this.listOfSelectedItemsBody;
        const dialogRef = this.dialog.open(ConsolidateShipmentsDetailsComponent, { width: '1000px', height: '600px' });
        dialogRef.componentInstance.createMode = false;
        dialogRef.componentInstance.summaryPage = true;
        dialogRef.componentInstance.info = data;
        dialogRef.componentInstance.saleOrders = _.cloneDeep(saleOrders);
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result.type == 'createPage' && result.status == 'open') {
                this.consolidateShipments(result.data)
            }

        });
    }

    ngOnDestroy(): void {
        this.uploadSubscription && this.uploadSubscription.unsubscribe();
    }

    openUploadDialog(): void {
        this.dialog.open(XlsxUploadPopupPopupComponent);
    }

    applyChanges(): void {
        if (!this.listOfSelectedItems.length) {
            this.notify.showError('Please select at least one SO');
            return;
        }

        let dialogRef = this.dialog.open(OriginCountryPopupDialog);

        dialogRef.componentInstance.countries = this.fullCountriesList;
        dialogRef.componentInstance.orderIds = this.listOfSelectedItems.map(el => Number(el));

        dialogRef.afterClosed().subscribe(value => {
            this.listOfSelectedItems = [];
            this.getList();
        })
    }

      selectAllData(): void {
        this.getList(
            1,
            9999999,
            this.searchStr.value,
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
                ? this.customerName.value
                : this.userSvc.company.id,
            true
        );
    }

    recalculateTaxReport() {
        this.showLoader = true;
        this.saleOrderSvc.recalculateTaxReport(this.listOfSelectedItems).subscribe(res => {
            this.getList();
            this.listOfSelectedItems = [];
            this.notify.showSuccessMessage('Recalculation complete successfully.');
        });
    }

    /*toggleAllSelection(control: FormControl, option: MatOption, countries: ICountry[]) {
        if (option.selected) {
            control
                .patchValue([...countries.map(item => item.name), 0]);
        } else {
            control.patchValue([]);
        }
    }

    toggleAllEUSelection(control: FormControl, option: MatOption, countries: ICountry[]) {
        if (option.selected) {
            const selectedCountries = [];
            countries.map(item => {
                if (item.name !== 'United Kingdom' && item.isEurope) {
                    selectedCountries.push(item.name);
                }
            })
            control
                .patchValue([...selectedCountries, 1]);
        } else {
            control.patchValue([]);
        }
    }*/

    clearFilters(): void {
        this.searchStr = new FormControl('');
        this.fromData = new FormControl('');
        this.fromDataEmpact = new FormControl('');
        this.toData = new FormControl('');
        this.toDataEmpact = new FormControl('');
        this.marketplaces = new FormControl(null);
        this.orderStatus = new FormControl(null);
        this.customerName = new FormControl('');
        this.originCountry = new FormControl('');
        this.destinationCountry = new FormControl('');
        this.deliveryFromDate = new FormControl('');
        this.deliveryToDate = new FormControl('');
        this.search();
    }


    uploadExcel(e): void {
        if (!e.target.files) {
            return;
        }
        const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
        if (!this.uploadFileSvc.excelFileFormats[0].split(', ').find(el => el === files[0].type)) {
            this.fileInput.nativeElement.value = '';
            this.notify.showError('Should contain only XLSX files');
            return;
        }
        //this.uploadFileSvc.uploadSeveralFile(files, `xlsx-sale-order-files/${this.selectedShop}`);
        this.uploadFileSvc.uploadSeveralFile(files, `xlsx-sale-order-files/upload/file`);
        this.sub$.add(
            this.uploadFileSvc.allFilesLoaded().subscribe(data => {
                if (!data) {
                    return;
                }
                let file = data[0];
                if (!file) {
                    return;
                }
                file = JSON.parse(file.data);
                this.notify.showSuccessMessage('Uploaded successfully');
                this.fileInput.nativeElement.value = '';
                this.uploadFileSvc.filesLoadedObserver.next(null);
                //this.dialog.close();
            })
        );
    }

    toggleAllEUSelection(control: FormControl, option: MatOption, countries: ICountry[]) {
        if (option.selected) {
            const selectedCountries = [];
            countries.map(item => {
                if (item.isEurope) {
                    selectedCountries.push(item.id);
                }
            })
            control
                .patchValue([...selectedCountries, 0]);
        } else {
            control.patchValue([]);
        }
    }

    toggleAllNonEUSelection(control: FormControl, option: MatOption, countries: ICountry[]) {
        if (option.selected) {
            const selectedCountries = [];
            countries.map(item => {
                if (!item.isEurope) {
                    selectedCountries.push(item.id);
                }
            })
            control
                .patchValue([...selectedCountries, -1]);
        } else {
            control.patchValue([]);
        }
    }
}
